import { PatientId, WithPatientId } from '../surgicalEvent.slice';
import { doctorBffApi } from '../../doctorBffApi.slice';
import { IntubationInfoService } from './intubationInfo.service';
import { IntubationInfo } from './intubationInfo.model';
import { wrapError } from '../../error';

export const intubationApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    intubationInfo: builder.query<IntubationInfo, PatientId>({
      queryFn: ({ patientId }) =>
        IntubationInfoService.getInstance(patientId).fetch().catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'Intubation', id: patientId }
      ]
    }),

    patchIntubationInfo: builder.mutation<
      IntubationInfo,
      WithPatientId<Partial<IntubationInfo>>
    >({
      queryFn: ({ patientId, ...intubation }) =>
        IntubationInfoService.getInstance(patientId)
          .patch(intubation)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'Intubation', id: patientId }
      ]
    })
  }),
  overrideExisting: false
});

export const { useIntubationInfoQuery, usePatchIntubationInfoMutation } =
  intubationApi;
